/**
 * Placeholder waiver shown on public signup when the tenant has not configured any waivers.
 * Text is long enough to require scrolling before the acceptance checkbox is enabled.
 */

export const PLACEHOLDER_WAIVER_POLICY_ID = 0;

export const PLACEHOLDER_WAIVER_NAME =
  "Placeholder waiver (no studio waivers configured yet)";

/**
 * Builds the display text for the placeholder waiver. Uses tenant name when available.
 */
export function getPlaceholderWaiverDisplayText(tenantDisplayName: string): string {
  return `This is a placeholder waiver. It is shown because ${tenantDisplayName} has not yet configured waivers and policies in the admin panel.

When a studio has not added their own waivers, this test waiver appears so that the signup form and its validation (including the requirement to scroll and accept) work the same way as when real waivers are configured. Once the studio adds waivers in the admin dashboard, those will be shown here instead of this message.

You can proceed by scrolling to the bottom of this text and checking the acceptance box below. Doing so confirms you have seen this notice. If you have questions about terms or waivers, please contact ${tenantDisplayName} after registering.

This paragraph is here so that the content is long enough to require scrolling within the waiver box. Please scroll down to the bottom to enable the acceptance checkbox. The same scroll-to-accept behaviour applies whether the studio has configured their own waivers or is still using this placeholder.

Thank you for your patience. After you create your account, you may be asked to review and accept additional policies or waivers in the Parent or Member portal before enrolling in classes.`;
}
